document.addEventListener('DOMContentLoaded', function() {
  const keyFeaturesList = document.querySelector('.key-features-list');

  if (keyFeaturesList) {
    const ulElement = keyFeaturesList.querySelector('ul');
    ulElement.style.display = 'flex';
    ulElement.style.flexDirection = 'column';
    ulElement.style.gap = '10px'; 

    const listItems = keyFeaturesList.querySelectorAll('li');
    const iconPath = 'https://cdn.shopify.com/s/files/1/0589/9078/8776/files/8e25b3ee802c33bf05636c85d95f374c.png?v=1790857364';

    listItems.forEach(li => {
      // Check if li has text content (trim whitespace)
      if (li.textContent.trim() === '') {
        return; // Skip this li if it's empty
      }

      const icon = document.createElement('img');
      icon.src = iconPath;
      icon.alt = 'Icon';
      icon.style.width = '11px'; 
      icon.style.height = '18px'; 
      icon.style.marginRight = '8px';
      icon.style.objectFit = 'contain';

      // Add flexbox styles to the li element
      li.style.display = 'flex';
      li.style.alignItems = 'center';

      // Prepend the icon to the li element
      li.prepend(icon);
    });
  } else {
    console.log('Key features list not found');
  }
});